var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_906_1361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 19.5C18 17.8434 16.6566 16.5 15 16.5H13.5C10.1859 16.5 7.5 19.1859 7.5 22.5V27C7.5 30.3141 10.1859 33 13.5 33H15C16.6566 33 18 31.6566 18 30V19.5ZM34.5 33C37.8141 33 40.5 30.3141 40.5 27V22.5C40.5 19.1859 37.8141 16.5 34.5 16.5H33C31.3434 16.5 30 17.8434 30 19.5V30C30 31.6566 31.3434 33 33 33H34.5ZM24 0C10.6106 0 0.429375 11.1403 0 24V25.5C0 26.3288 0.67125 27 1.5 27H3C3.82875 27 4.5 26.3288 4.5 25.5V24C4.5 13.2478 13.2478 4.5 24 4.5C34.7522 4.5 43.5 13.2478 43.5 24H43.4888C43.4963 24.2278 43.5 39.5363 43.5 39.5363C43.5 41.7253 41.7253 43.5 39.5363 43.5H30C30 41.0147 27.9853 39 25.5 39H22.5C20.0147 39 18 41.0147 18 43.5C18 45.9853 20.0147 48 22.5 48H39.5363C44.2106 48 48 44.2106 48 39.5363V24C47.5706 11.1403 37.3894 0 24 0Z",
    fill: "#EF4444"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_906_1361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRed);
export default __webpack_public_path__ + "static/media/red.6b17dba6a8549a9e0bab6d8c2dbec37b.svg";
export { ForwardRef as ReactComponent };